import { Component, OnInit, ViewChild } from '@angular/core';
import { AccountPackageService } from '../../service/account-package.service';
import { UtilService } from '../../service/util.service';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { Constants } from '../../constants/constants';
import { NavigationExtras, Router } from '@angular/router';
import { ToastService } from '../../service/toast.service';
import { SearchResultsComponent } from '../../search-results/search-results.component';
import { SearchDataService } from '../../service/search-data.service';

@Component({
  selector: 'app-service-provider-account-management',
  templateUrl: './service-provider-account-management.component.html',
  styleUrls: ['./service-provider-account-management.component.scss']
})
export class ServiceProviderAccountManagementComponent implements OnInit {

  account;
  servicePackages: any = {};
  locations: Array<any> = new Array();
  activePackages: Array<any> = new Array();
  pkgList: Array<any> = new Array();
  connectedVehicles: number = 0;
  importFile: File = null;
  accountDetail: any;
  apiKeys: any = [];
  secretkeyVisibility: Array<boolean> = new Array();
  resetIndexSelected;

  isViewScreen: boolean = false;
  selectedPkgForView = null;

  //Search result storage variable
  @ViewChild('searchResult') searchResult:SearchResultsComponent;
  searchedLocationList: Array<any>;
  searchedServicePackageList: Array<any>;
  searchedVehicleList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;

  constructor(private accountServicePackage: AccountPackageService, private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private router: Router, private toast: ToastService, private searchService: SearchDataService) { }

  ngOnInit() {
    this.account = this.apiService.accountDetail;
    this.servicePackages = this.accountServicePackage.getServicePackage();
    this.getAccountDetail();
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });
  }

  private processSearchResult() {
    this.searchedVehicleList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    this.searchedLocationList = this.searchService.getSearchedDataForType(Constants.LOCATIONS);
    this.searchedServicePackageList = this.searchService.getSearchedDataForType(Constants.SERVICE_PACKAGE);
    this.selectedSearchItemForView = null;
    if ((this.searchedVehicleList && this.searchedVehicleList.length > 0) ||
      (this.searchedLocationList && this.searchedLocationList.length > 0) ||
      (this.searchedServicePackageList && this.searchedServicePackageList.length > 0)) {
      this.isViewScreen = false;
      this.showSearchResult = true;
    } else {
      this.showSearchResult = false;
    }
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  onSearchItemDetail(searchItem: string) {
    this.selectedSearchItemForView = searchItem;
  }

  onNavSearchClick() {
    this.searchResult.onNavSearchClick();
  }

  getActivePackages() {
    this.pkgList.forEach(element => {
      if (element.inUse) {
        this.activePackages.push(element);
      }
    });
  }

  onFileSelected(files: FileList, type: string) {
    this.importFile = null;
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      if (this.isCsvFile(file.name) && this.isValidFileName(file.name, type)) {
        this.importFile = file;
      }
    }
  }

  uploadFile() { 
    let formData: FormData = new FormData();
    formData.append('file', this.importFile, this.importFile.name);
    this.uploadCsvFile(formData);
  }

  isFileSelected(files: FileList) {
    if (files && files.length > 0)
      return true;
    return false;
  }

  isCsvFile(name: string) {
    let splitStr = name.split('.');
    let extension = splitStr[splitStr.length - 1];
    if (extension.toLowerCase() != 'csv') {
      this.toast.showError("Please select .csv file only");
      return false;
    }
    return true;
  }

 isValidFileName(name: string, type: string) {
    let splitStr = name.split('_');
    if(splitStr.length < 4) {
      this.toast.showError("Invalid file name format. Expected file name format: NCC_" + type + "_" + this.accountDetail.id + "_05132019101630.csv");
      return false;
    }
    let importType = splitStr[1];
    let accountId = splitStr[2];
    if(importType != type) {
      this.toast.showError("Invalid file name format. Expected file name format: NCC_" + type + "_" + this.accountDetail.id + "_05132019101630.csv");
      return false;
    }
    if(accountId != this.accountDetail.id) {
      this.toast.showError("The accountId in the filename doesn't match the selected fleet's accountId.");
      return false;
    }
    return true;
  }

  uploadCsvFile(formData: FormData) {
    this.utilService.showSpinner();
    this.apiService.uploadCsvFile(formData).then((data) => {
      this.utilService.hideSpinner();
      console.log("file upload response :: ", data);
      this.toast.showSuccess(data.message);
      this.importFile = null;
      document.getElementById("closeImportupdatePackage").click();
    }).catch((error) => {
      console.log("err : ", error);
      this.importFile = null;
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.uploadCsvFile(formData);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getAccountDetail() {
    this.utilService.showSpinner();
    this.apiService.getAccountPackageLocationDetail().then((data) => {
      this.utilService.hideSpinner();
      this.accountDetail = data;
      // this.pkgList = data.servicePackages;
      this.getPackageList();
      // this.pkgList = this.accountServicePackage.setPackageRatePlan(data.servicePackages);
      if(this.account.category == Constants.FLEET_MANAGEMENT_COMPANY) {
        this.locations = [];
        data.locations.forEach(element => {
          if(element.type == "FACILITY") {
            this.locations.push(element);
          }
        });
      } else {
        this.locations = data.locations;
      }
      this.connectedVehicles = data.vehicles;
      this.utilService.selectedRentalFleetAccount = this.accountDetail;
      console.log("Account detail from API::", this.accountDetail);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }
  
  getPackageList() {
    this.utilService.showSpinner();
    this.apiService.getAccountServicePackageList().then((data) => {
      this.utilService.hideSpinner();
      this.pkgList = this.accountServicePackage.setPackageRatePlan(data);
      console.log("service package from API::", this.pkgList);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPackageList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  goToServicePackages() {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "connectedVehicles": this.connectedVehicles
      }
    };

    this.router.navigate(['/service-packages'], navigationExtras);
  }

  packageClickedForView(pkg) {
    this.isViewScreen = true;
    this.selectedPkgForView = JSON.parse(JSON.stringify(pkg));
  }

  closeOfViewClicked(data) {
    this.isViewScreen = false;
  }

  showVehicle(): boolean {
    if(this.account && (this.account.type == "FLEET_CONSUMER_SERVICE" || this.account.type == "FLEET_COMMERCIAL_SERVICE" || (this.account.type == "VEHICLE_SERVICE_PROVIDER" && 
      this.account.category == "MOBILITY_SERVICE"))) {
        return true;
    }
    return false;
  }

}
